// extracted by mini-css-extract-plugin
module.exports = {"root":"Services_root__q4B1_"};